<script setup>
import { useTheme } from 'vuetify'

const props = defineProps({
  enabled: { type: Boolean, default: false },
})

defineEmits(['showRegionsOverlay'])

const theme = useTheme()
</script>

<template>
  <v-chip
    class="px-4"
    prepend-icon="mdi-map-marker-radius"
    :append-icon="props.enabled ? 'mdi-check-circle' : undefined"
    variant="elevated"
    :color="props.enabled ? 'primary' : theme.current.value.colors.surface"
    @click="$emit('showRegionsOverlay')"
  >
    {{ $t('canvas.settings.overlay.regions.title') }}
  </v-chip>
</template>
